import React from "react";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const img = "https://customer-assets-lqy194kg.emergentagent.net/job_museo-urbino-hub/artifacts/f8j7mbdk__DSC0224.webp";
const img2 = "https://customer-assets-lqy194kg.emergentagent.net/job_museo-urbino-hub/artifacts/80jiz9oh_TIPO.webp";
const img3 = "https://customer-assets-lqy194kg.emergentagent.net/job_museo-urbino-hub/artifacts/kllubd46_46943319_1395173813951045_4774978849660207104_n.jpg";

export default function Museum() {
  return (
    <Layout>
      {/* HERO */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-16">
        <div className="overline">Museum Graphia & La Corte della Miniera</div>
        <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] mt-3 max-w-4xl">
          Cultura, formazione e ospitalità<br/><em className="text-[#8C3A27] not-italic">nel cuore del Rinascimento.</em>
        </h1>
        <p className="mt-6 max-w-3xl text-[#6B6960] leading-relaxed text-lg">
          Nel cuore del Montefeltro, a pochi minuti da Urbino, <strong>Museum Graphia — Museo Internazionale
          della Stampa</strong> e <strong>La Corte della Miniera</strong> costituiscono un luogo unico nel quale
          cultura, arte, formazione, ospitalità e territorio si incontrano. Non siamo semplicemente un museo
          e una struttura ricettiva: siamo un ecosistema culturale ed educativo nel quale il patrimonio storico
          diventa esperienza, la conoscenza diventa pratica e il viaggio diventa occasione di apprendimento.
        </p>
      </section>

      {/* URBINO */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 pb-24">
        <div className="lg:col-span-7 aspect-[4/3] overflow-hidden">
          <img src={img} alt="La Corte della Miniera" className="w-full h-full object-cover" />
        </div>
        <div className="lg:col-span-5">
          <div className="overline">Urbino</div>
          <h2 className="font-display text-4xl mt-3">La città dove l'Europa imparò a pensare.</h2>
          <p className="mt-4 text-[#6B6960] leading-relaxed">
            Nel Quattrocento, sotto Federico da Montefeltro, Urbino divenne uno dei più importanti centri
            culturali europei: Piero della Francesca, Leon Battista Alberti, Paolo Uccello, Francesco di
            Giorgio Martini. Qui maturarono figure come <strong>Raffaello, Bramante e Luca Pacioli</strong>.
          </p>
          <p className="mt-4 text-[#6B6960] leading-relaxed">
            Nel 1998 il centro storico è stato inserito nella <strong>Lista del Patrimonio Mondiale UNESCO</strong>.
            È questo il contesto nel quale operiamo: non un semplice luogo da visitare, ma un territorio nel
            quale la storia è ancora oggi strumento di formazione.
          </p>
        </div>
      </section>

      {/* MUSEUM GRAPHIA */}
      <section className="bg-[#2A312B] text-[#F9F8F6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="overline text-[#D7B565]">Museum Graphia</div>
            <h2 className="font-display text-4xl lg:text-5xl mt-3">La stampa come arte, conoscenza e libertà.</h2>
            <div className="mt-8 aspect-[4/5] overflow-hidden">
              <img src={img2} alt="Torchio Museum Graphia" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-[#F9F8F6]/85 leading-relaxed space-y-4">
            <p>
              Museum Graphia nasce dalla volontà di conservare e — soprattutto — di rendere viva la cultura
              della stampa: una delle grandi rivoluzioni della civiltà europea, che ha permesso alle idee
              di circolare, alla conoscenza di essere condivisa, alle persone di comunicare oltre i limiti
              del proprio tempo.
            </p>
            <p>
              Non interpretiamo la stampa soltanto come patrimonio tecnico. La interpretiamo come
              <strong> patrimonio culturale e umano</strong>. Le nostre attività permettono di entrare
              concretamente nel mondo della grafica e della stampa attraverso laboratori di tipografia,
              litografia, calcografia, serigrafia, xilografia e stampa d'arte.
            </p>
            <p>
              Il visitatore diventa protagonista: tocca i materiali, comprende le tecniche, sperimenta,
              sbaglia, corregge e produce. È un modello di <em>learning by doing</em> adatto a scuole,
              studenti, insegnanti, professionisti, adulti e gruppi internazionali. La tradizione diventa
              strumento per sviluppare <strong>creatività, precisione, collaborazione, comunicazione,
              capacità progettuale e problem solving</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* CORTE DELLA MINIERA */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <div className="overline">La Corte della Miniera</div>
          <h2 className="font-display text-4xl lg:text-5xl mt-3">Vivere il territorio, imparare attraverso l'esperienza.</h2>
          <p className="mt-6 text-[#6B6960] leading-relaxed">
            A completare l'esperienza è La Corte della Miniera, struttura di ospitalità e centro per
            attività culturali, formative ed esperienziali. L'ospitalità qui non è separata dalla formazione:
            gli ospiti soggiornano, mangiano, lavorano, partecipano ai laboratori e vivono attività
            culturali dentro un unico sistema organizzato.
          </p>
          <p className="mt-4 text-[#6B6960] leading-relaxed">
            Costruiamo percorsi personalizzati per scuole, università, gruppi internazionali, organizzazioni
            formative e adulti — integrando soggiorno, formazione e scoperta del territorio.
          </p>
        </div>
        <div className="lg:col-span-6 aspect-[4/5] overflow-hidden">
          <img src={img3} alt="Caratteri mobili in lavorazione" className="w-full h-full object-cover" />
        </div>
      </section>

      {/* MONTEFELTRO */}
      <section className="bg-[#EBE8E0] paper-grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="overline">Il Montefeltro</div>
            <h2 className="font-display text-4xl lg:text-5xl mt-3">Un'aula a cielo aperto.</h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-[#1A1A1A]/80 leading-relaxed space-y-3">
            <p>
              La nostra attività non termina all'interno del museo. <strong>Urbino, Gradara, Urbania,
              San Marino</strong> e gli altri centri storici del Montefeltro permettono di costruire
              percorsi nei quali arte, storia, letteratura, architettura, artigianato, ambiente e
              tradizioni locali si intrecciano.
            </p>
            <p>
              Un palazzo diventa una lezione di storia. Un laboratorio artigiano una lezione sul lavoro.
              Un'opera d'arte una lezione sulla società. Una tecnica antica una riflessione sull'innovazione.
            </p>
          </div>
        </div>
      </section>

      {/* FORMAZIONE / EUROPA */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24">
        <div className="overline">Formazione continua & cooperazione europea</div>
        <h2 className="font-display text-4xl lg:text-5xl mt-3 max-w-3xl">La cultura europea, qualcosa da vivere.</h2>
        <p className="mt-6 max-w-3xl text-[#6B6960] leading-relaxed">
          Museum Graphia e La Corte della Miniera collaborano con istituzioni educative e culturali
          italiane ed europee: <strong>Erasmus+, VET, Adult Education, Job Shadowing</strong>, formazione
          degli insegnanti, mobilità degli studenti, viaggi studio, visite educative e programmi di
          approfondimento culturale.
        </p>
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 max-w-3xl">
          {["CULTURE","EDUCATION","EXPERIENCE","EUROPE"].map((w) => (
            <div key={w} className="border border-[#E2DFD6] px-4 py-4 text-center overline">{w}</div>
          ))}
        </div>
        <div className="mt-10 flex gap-3">
          <Link to="/prenota"><Button className="btn-primary-cdm rounded-full h-11 px-6">Prenota una visita</Button></Link>
          <Link to="/servizi"><Button variant="outline" className="rounded-full h-11 px-6 border-[#1A1A1A]/20">Vedi tutti i laboratori</Button></Link>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        <div className="border-t border-[#E2DFD6] pt-8 text-center overline text-[#6B6960]">
          Museum Graphia &amp; La Corte della Miniera · Urbino — Montefeltro — Italy
        </div>
      </section>
    </Layout>
  );
}
